const en = {
  translation: {
      ui: {
        viewMode: {
          floorPlan: {
            label: "Floor Plan",
            description: "View the apartment from above."
          },
          threeD: {
            label: "3D",
            description: "View the apartment in 3D."
          },
          dollhouse: {
            label: "Dollhouse",
            description: "View the apartment in dollhouse mode."
          }
        },
        loadingState: {
          loading: "Loading...",
          error: "Error loading content",
          initial: "Initializing..."
        },
        commandButton: {
          disabledDueToActiveCommand: "Command cannot be launched while another command is active",
          disableDueToRights: "You do not have the required rights to execute this command",
          clickToCancelCommand: "Click to cancel command"
        },
        storeySelector: {
          title: "Click to go to next storey",
          nameFormat: "{{ordinal}} Floor"
        },
        roomNote: {
          dialog: {
            noteSection: "Note",
            notePlaceholder: "Write a note for this room",
            saving: "Saving…",
            error: {
              validation: "The note couldn't be saved. Check that it is at most 2000 characters.",
              unauthorized: "Your session has expired. Reload the page to sign in again.",
              forbidden: "You don't have permission to edit notes.",
              notFound: "This room was not found in the apartment. Reload the page to refresh the model.",
              failed: "Couldn't save, try again."
            }
          }
        },
        selectionToolbar: {
          info: "Properties",
          move: "Move",
          clone: "Clone",
          delete: "Delete",
          type: {
            lengthDimension: "Dimension",
            textAnnotation: "Text",
            areaAnnotation: "Area",
            rectangleAnnotation: "Rectangle",
            circleAnnotation: "Circle",
            checklistItem: "Checklist item",
            object: "Object"
          }
        },
        editHandle: {
          tooltip: {
            startPoint: "Move start point",
            endPoint: "Move end point",
            dimensionOffset: "Adjust offset",
            polygonVertex: "Move vertex",
            rectangleCorner: "Move corner point",
            circleRadius: "Set circle radius",
            extrusionDepth: "Set thickness"
          }
        },
        propertiesPanel: {
          title: "Properties",
          readOnly: "Read only",
          multipleValues: "Multiple values",
          varies: "Varies",
          variesDescription: "Value varies across the selection. Changing it applies to all {{count}} selected elements.",
          mixedNote_one: "Dashed fields differ between the {{count}} selected element. Setting one applies it to all {{count}}.",
          mixedNote_other: "Dashed fields differ between the {{count}} selected elements. Setting one applies it to all {{count}}.",
          selectionCount_one: "{{count}} {{type}} element",
          selectionCount_other: "{{count}} {{type}} elements",
          elementsCount_one: "{{count}} element",
          elementsCount_other: "{{count}} elements"
        }
      },
      properties: {
        category: {
          common: {
            name: "General"
          },
          dimensions: {
            name: "Dimensions"
          }
        },
        field: {
          textContent: {
            name: "Text"
          },
          fontSize: {
            name: "Font size"
          },
          rectWidth: {
            name: "Width"
          },
          rectHeight: {
            name: "Height"
          },
          circleRadius: {
            name: "Radius"
          },
          showAreaText: {
            name: "Show area"
          },
          extrusionDepth: {
            name: "Thickness"
          },
          showVolume: {
            name: "Show volume"
          },
          color: {
            name: "Color"
          }
        }
      },
      command: {
        addLengthDimension: {
          title: "Add length dimension",
          selectFirstPoint: "Select first point", 
          selectSecondPoint: "Select second point",
          setOffset: "Set offset",
        },
        addTextAnnotation: {
          title: "Add text annotation",
          setReferencePoint: "Set reference point for text annotation",
          setTextPosition: "Set position",
          enterText: "Enter text for annotation and select font size",
          dialog: {
            enterText: "Enter text for note",
            noteTextSection: "Note text",
            notePlaceholder: "Type the note…",
            addNote: "Add note",
            fontSize: "Font size",
            fontSizeSmallest: "Smallest",
            fontSizeSmall: "Smaller",
            fontSizeMedium: "Default",
            fontSizeLarge: "Bigger"
          }
        },
        addChecklistItem: {
          title: "Add checklist item",
          setPosition: "Click a position in the scene to place the checklist item",
          confirmPosition: {
            title: "Confirm position",
            text: "Is the checklist item in the correct position?",
          },
        },
        addAreaAnnotation: {
          title: "Add area",
          selectFirstPoint: "Click a surface to start the profile",
          selectNextPoint: "Click to add more points, or click Finish when done",
          finish: "Finish"
        },
        addRectangleAnnotation: {
          title: "Add rectangle",
          selectFirstPoint: "Click a surface to set the first corner",
          selectSecondPoint: "Click to set the opposite corner",
          finish: "Finish"
        },
        addCircleAnnotation: {
          title: "Add circle",
          selectFirstPoint: "Click a surface to set the center",
          selectSecondPoint: "Click to set the radius",
          finish: "Finish"
        },
        removeFromDocument: {
          title: "Remove annotation",
          selectObjectToRemove: "Select object to remove from document.",
          clickToRemove: "Click to remove.",
          noPermission: "You do not have permission to delete this object.",
          objectRemoved: "Object removed."
        },
        focusOnSceneObject: {
          title: "Focus on object"
        },
        select: {
          title: "Select",
          hover: "Click on an object to select it"
        },
        geometryMoveEdit: {
          title: "Move",
          prompt: "Click to place"
        },
        moveSceneObjects: {
          title: "Move",
          prompt: "Click an arrow or a plane to start moving, or click outside to finish",
          promptDragging: "Move to a new position and click to place"
        },
        cloneSceneObjects: {
          title: "Clone",
          prompt: "Set position of the clone"
        },
        bundleInspector: {
          title: "Bundle Inspector",
          loading: "Loading bundles…",
          prompt: "Hover an element to see its bundle, click it for details",
          loadFailed: "Couldn't load bundles. Cancel and try again.",
          noBundle: "No bundle",
          multipleBundles: "Element belongs to {{count}} bundles",
          units: {
            pcs: "pcs"
          },
          panel: {
            overview: "Overview",
            elements: "Elements",
            tabs: "Bundle details",
            material: "Material",
            noMaterial: "No material selected",
            noElements: "No elements.",
            disabled: "Disabled",
            statePrefix: "Status:",
            states: {
              open: "Open",
              locked: "Locked",
              confirmed: "Confirmed"
            },
            moreActions: "More actions",
            detachElements: "Detach elements",
            detachHints: {
              locked: "Unlock the line first.",
              confirmed: "Confirmed lines can’t be changed.",
              noElements: "No elements to detach.",
              singleElement: "A bundle must keep at least one element."
            }
          }
        },
        detachBundleElements: {
          title: "Detach elements",
          prompt_one: "Click elements to detach · {{count}} selected",
          prompt_other: "Click elements to detach · {{count}} selected",
          detach: "Detach",
          dialog: {
            title: "Detach elements",
            from: "from {{name}}",
            elements: "Elements ({{count}})",
            newBundle: "New bundle",
            name: "Name",
            namePlaceholder: "{{name}} (New)",
            level: "Level",
            levels: {
              apartment: "Apartment",
              room: "Room"
            },
            apartmentHelp: "The new bundle applies to the whole apartment, not to one room.",
            room: "Room",
            roomPlaceholder: "Select a room…",
            roomHelp: "Select a room to continue. Only rooms in this apartment are listed.",
            note: "The new bundle starts as a copy of {{name}}, with the same material and prices.",
            detach_one: "Detach {{count}} element",
            detach_other: "Detach {{count}} elements",
            detaching: "Detaching…",
            errors: {
              Forbidden: "You don't have permission to change bundles.",
              DifferentApartment: "That room is in a different apartment. Choose another room.",
              SeveralBundles: "These elements belong to more than one bundle. Detach them one bundle at a time.",
              Failed: "Couldn’t detach the elements. Try again."
            }
          }
        },
        geometryDirectionalMove: {
          title: "Move",
          prompt: "Move to a new position and click to place"
        },
        extrudedLoopAreaSetExtrusionDepth: {
          title: "Set depth",
          prompt: "Drag to change the extrusion depth, then click to set"
        },
        geometryPlanarMove: {
          title: "Move",
          prompt: "Move to a new position and click to place"
        },
        geometryFreeMove: {
          title: "Move",
          prompt: "Move to a new position and click to place"
        },
        switchInputPlane: "Switch input plane",
        switchInputPlaneTooltip: "Define dimension along the surface plane or away from surface plane. Shortcut: Right click",
      },
      document: {
        userRights: {
          tooltip: "User rights",
          create: "Create",
          read: "Read",
          update: "Update",
          delete: "Delete",
          scopeAll: "All",
          scopeGroup: "Group",
          scopeOwn: "Own",
          scopeNoRights: "No rights",
        }
      },
      common: {
        ok: "OK",
        cancel: "Cancel",
        save: "Save",
        close: "Close",
        abort: "Abort",
        yes: "Yes",
        no: "No",
      },
      debug: {
        viewerModeInspect: "Inspect",
      }
    }
};

export default en;
